module.exports = __webpack_public_path__ + "static/img/googlecalendar2.b96f28d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/googlecalendar2.png
// module id = 1423
// module chunks = 1